import { Button } from '~/components/ui/Button';
import { WidgetText, WidgetTitle, WrapperWidget } from '@agentselly/ui';
import { AppLink } from '~/components/AppLink';
import { useTranslate } from '@tolgee/react';

export function HeroCTAWidget(props: Props) {
  const { t } = useTranslate();

  return (
    <WrapperWidget>
      <div className="h-full flex flex-col xl:flex-row xl:items-center xl:justify-between gap-6">
        <div className="flex-1">
          <WidgetTitle className="pb-2 text-xl font-semibold text-gray-900 dark:text-gray-100">
            {t(props.title)}
          </WidgetTitle>
          <WidgetText className="text-sm text-gray-600 dark:text-gray-400">
            {t(props.message)}
          </WidgetText>
        </div>
        <div className="flex items-center">
          {props.cta?.link?.startsWith('http') ? (
            <a
              href={props.cta?.link}
              target="_blank"
              rel="noopener noreferrer"
              className="self-start"
            >
              <Button
                primary={props.cta?.isPrimary}
                showArrow
              >
                {t(props.cta?.buttonText)}
              </Button>
            </a>
          ) : (
            <AppLink
              to={props.cta?.link}
              className="self-start"
            >
              <Button
                primary={props.cta?.isPrimary}
                showArrow
              >
                {t(props.cta?.buttonText)}
              </Button>
            </AppLink>
          )}
        </div>
      </div>
    </WrapperWidget>
  );
}

interface Props {
  readonly title: string;
  readonly message: string;
  readonly cta: {
    readonly buttonText: string;
    readonly link: string;
    readonly isPrimary?: boolean;
  };
}
